import { z } from "zod";

/** One indemnity line as returned with a profile (API) and stored inside profile JSONB. */
export const remunerationProfileIndemnityViewSchema = z.object({
  id: z.guid(),
  /** Primary PLD IdPrime (non-taxable when mixed pair). */
  pld_prime_id: z.string().min(1),
  /** Taxable PLD IdPrime when S/N pair; omitted for single-nature primes. */
  pld_prime_id_taxable: z.string().min(1).optional(),
  name: z.string().min(1),
  /** Free text sent to Tempo as `LibPrimeComplement`. Blank stays unset. */
  complement_label: z.string().optional(),
  amount: z.number(),
  amount_non_taxable: z.number(),
  coefficient: z.number(),
  taxable_coefficient: z.number(),
});

export type RemunerationProfileIndemnityView = z.infer<typeof remunerationProfileIndemnityViewSchema>;

/** Payload for one indemnity line (POST/PATCH body): no row id; coefficients default to 1. */
export const remunerationIndemnityPayloadSchema = remunerationProfileIndemnityViewSchema
  .omit({
    id: true,
  })
  .extend({
    coefficient: z.number().default(1),
    taxable_coefficient: z.number().default(1),
  });

export const remunerationIndemnityUpdatePayloadSchema = remunerationIndemnityPayloadSchema.partial();

export type RemunerationIndemnityPayload = z.infer<typeof remunerationIndemnityPayloadSchema>;
export type RemunerationIndemnityUpdatePayload = z.infer<typeof remunerationIndemnityUpdatePayloadSchema>;
